import {
  GET_ACCOUNT,
} from './/mutation-types';
import md5 from 'md5';

export default {
  [GET_ACCOUNT](state, user) {
    state.email = user.email;
    state.username = user.username;
    state.name = `${user.firstname} ${user.lastname}`;

    if (state.email) {
      // get gravatar
      state.avatarLink = `https://www.gravatar.com/avatar/${md5(user.email)}`;
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/account/mutations.js